import { FormValidationDefinition } from "../../../../../common/components/form/use-form";
import cargoDispatchFormValidationService from "./cargo-dispatch-validation.service";
import CargoDispatchFormData from "./types/cargo-dispatch-form-data";

const getEmptyFormData = (): CargoDispatchFormData => {
  return {
    name: "",
    displayName: "",
    address: "",
  };
};

const getValidationDefinition =
  (): FormValidationDefinition<CargoDispatchFormData> => {
    return {
      name: (values) =>
        cargoDispatchFormValidationService.validateName(values.name),
      displayName: (values) =>
        cargoDispatchFormValidationService.validateDisplayName(
          values.displayName
        ),
      address: (values) =>
        cargoDispatchFormValidationService.validateAddress(values.address),
    };
  };

const cargoDispatchFormHelper = {
  getEmptyFormData,
  getValidationDefinition,
};

export default cargoDispatchFormHelper;
